import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./reset-password.css";
import Footer from "../footer/footer.js";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { handleError, handleSuccess } from "../../utils.js";
import logo from "../../assets/wjcw_logo.png";
import http from "../../core/service/http.js";
import Header from "../header/header.js";

export const useResetPasswordHook = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Validation Schema
  const validationSchema = Yup.object({
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm password is required."),
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // Sending a POST request with axios
      const response = await http.post(
        "/v1/auth/reset-password?token=" + searchParams.get("token"),
        {
          password: values.password,
        }
      );

      handleSuccess("Password reset successfully.");
      navigate("/");
      resetForm(); // Clear the form
    } catch (error) {
      console.error("Error sending reset email:", error);
      if (error.response) {
        // Server responded with an error status
        handleError(error.response.data.message);
      } else {
        // No response or network error
        handleError("Network error. Please try again later.");
      }
    }
    setSubmitting(false);
  };

  return {
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    searchParams,
    validationSchema,
    togglePasswordVisibility,
    toggleConfirmPasswordVisibility,
    handleSubmit
  };
};
